import React from 'react';

import BlogPanel from '@tovia/man-ui/lib/components/Blog/BlogPanel';
import NewsletterForm, { newsletterForm } from '../NewsletterForm/NewsletterForm';

import { STATUS_OPTED_IN, TYPE_TOP_10 } from 'src/shared/constants/newsletter';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';

// eslint-disable-next-line react/require-default-props
export default function NewsletterPanelClass({ className = '' }: { className?: string }) {
  const { status, submitted } = useSelector((state) => state.newsletter);

  if (status === STATUS_OPTED_IN && !submitted) {
    return null;
  }

  return (
    <BlogPanel headline="Get Free Content" className={className}>
      <div>
        <NewsletterForm newsletterType={TYPE_TOP_10} form={newsletterForm} submitBtnClassName="btn btn-primary" />
      </div>
    </BlogPanel>
  );
}
